<app-jinni-modal [(visible)]="showModal">
  <div class="casinoWelcome">
    <div class="jinnHead {{gender}}"></div>
    <h1 class="welcomeDiego">{{ 'casinoWelcome.welcome' | translate }} {{name}}!</h1>
    <h2 class="weAreThrilled">{{ 'casinoWelcome.weAreThrilled' | translate }}</h2>
    <div class="firstDepositBonus">
      <span class="firstDeposit">{{ 'casinoWelcome.firstDeposit' | translate }}</span>
      <span class="fullPrecent"></span>
      <span class="upTo currency_{{currency.Code}}">{{ 'casinoWelcome.upTo' | translate }} {{currency.Symbol}}<span *ngIf="currency.Code !== 'NGN'">300</span><span *ngIf="currency.Code === 'NGN'">120,000</span></span>
      <span class="freeSpins">
        <span class="plus">+</span>
        <span class="text">{{ 'casinoWelcome.freeSpins' | translate }}</span>
      </span>
      <span class="minimum currency_{{currency.Code}}">{{ 'casinoWelcome.minimumDeposit' | translate }} {{currency.Symbol}}<span *ngIf="currency.Code !== 'NGN'">10.00</span><span *ngIf="currency.Code === 'NGN'">4,000</span>. <a href="/bonus-policy" target="_blank">{{ 'casinoWelcome.termsApply' | translate }}</a></span>
    </div>
    <button class="claimYourBonus przycisk green big" (click)="cta();" [disabled]="waitBeforeClose" [ngClass]="{'spinner': waitBeforeClose}">{{ 'casinoWelcome.claimBonus' | translate }}</button>
    <span class="maybeLater" (click)="closeModal();">{{ 'casinoWelcome.maybeLater' | translate }}</span>
  </div>
  <div class="closeModal" (click)="closeModal();"></div>
</app-jinni-modal>
